import _ from 'lodash';

const isActive = filterValue => {
  if (_.isArray(filterValue)) {
    return filterValue.length > 0;
  }
  return !!filterValue;
};

const buildTerms = (rules, filters) => {
  return Object.entries(filters).reduce((terms, filter) => {
    let [key, value] = filter;
    if (rules[key] && isActive(value)) {
      rules[key](terms, value, filters);
    }
    return terms;
  }, {});
};

// Rules

const enquiryStatuses = (terms, enquiryStatuses) => {
  terms['nested.enquiries.status.id'] = enquiryStatuses;
};

const answers = (terms, answers) => {
  _.forEach(answers, function(value, key) {
    if (value.length > 0) {
      terms['nested.answerset.answer.id.' + key] = value;
    }
  });
};

const customerOwners = (terms, owners) => {
  if (!owners.includes(null)) {
    terms['owner.id'] = owners;
  }
};

const referralOwners = (terms, owners) => {
  if (!owners.includes(null)) {
    terms['owner_id'] = owners;
  }
};

const providerReference = (terms, providerReference) => {
  terms['nested.enquiries.provider_reference'] = [providerReference];
};

const productId = (terms, productId) => {
  terms['nested.enquiries.product.id'] = [productId];
};

const providerId = (terms, providerId) => {
  terms['nested.enquiries.provider.id'] = [providerId];
};

const revolvingEnquiries = terms => {
  terms['nested.enquiries.revolving'] = [true];
};

const referrer = (terms, referrer) => {
  if (referrer.parent_id) {
    terms['referrer.id'] = [referrer.id];
  } else {
    terms['referrer.account_id'] = [referrer.account_id];
  }
};

const customerReferrerType = (terms, referrerType) => {
  terms['referrer.type'] = referrerType === 'partner' ? ['partner', 'sub_partner'] : [referrerType];
};

const referralReferrerType = (terms, referrerType) => {
  terms['referrer.business_type'] = referrerType === 'partner' ? ['partner', 'sub_partner'] : [referrerType];
};

const newsletterSignup = (terms, newsletterSignup) => {
  terms['nested.users.newsletter_signup'] = [newsletterSignup];
};

const journeyId = (terms, journeyId) => {
  terms['active_journey.id'] = [journeyId];
};

const customerRules = {
  enquiryStatuses,
  answers,
  owners: customerOwners,
  providerReference,
  productId,
  providerId,
  revolvingEnquiries,
  referrer,
  referrerType: customerReferrerType,
  newsletterSignup,
  journeyId
};

const referralRules = {
  enquiryStatuses,
  owners: referralOwners,
  referrer,
  referrerType: referralReferrerType
};

export const customerTermsBuilder = filters => buildTerms(customerRules, filters);
export const referralTermsBuilder = filters => buildTerms(referralRules, filters);
